import cn from 'classnames';

import css from './actions.module.scss';
import Copy from './copy.icon.svg';

interface Props {
    value: string;
    onRefresh(): void;
}
export function Actions({ value, onRefresh }: Props) {
    return (
        <div className={css.actions}>
            <button className={cn(css.button, css.primary)} onClick={() => navigator.clipboard.writeText(value)}>
                <span className={css.icon}>
                    <Copy />
                </span>
                Copy key
            </button>

            <button className={css.button} onClick={onRefresh}>
                <span className={css.icon}>↻</span> Refresh
            </button>
        </div>
    );
}
